var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex rounded-2xl",
      class: _vm.containerClasses,
      staticStyle: { "background-color": "white" },
    },
    [
      _c(
        "div",
        { staticClass: "w-5/12 ml-8", class: _vm.leftClasses },
        [_vm._t("left-side")],
        2
      ),
      _c("div", { staticClass: "w-0/12" }, [_vm._t("middle-side")], 2),
      _c(
        "div",
        { staticClass: "w-7/12", class: _vm.rightClasses },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }